export default __webpack_public_path__ + "static/media/zoomIn.d73b0274.svg";